var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI07Question(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 23.0376H16.25L10.6875 26.7375C9.86248 27.2875 8.75 26.7001 8.75 25.7001V23.0376C5 23.0376 2.5 20.5376 2.5 16.7876V9.28749C2.5 5.53749 5 3.03749 8.75 3.03749H21.25C25 3.03749 27.5 5.53749 27.5 9.28749V16.7876C27.5 20.5376 25 23.0376 21.25 23.0376Z",
    stroke: "white",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 14.2V13.9375C14.9998 13.0875 15.5248 12.6375 16.0498 12.275C16.5623 11.925 17.0747 11.475 17.0747 10.65C17.0747 9.50002 16.1498 8.57498 14.9998 8.57498C13.8498 8.57498 12.9248 9.50002 12.9248 10.65",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9944 17.1875H15.0056",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI07Question);
export default __webpack_public_path__ + "static/media/I07-question.2b6bc29893efe34c2cc2b391b7b2276d.svg";
export { ForwardRef as ReactComponent };